import React from 'react';

export const IconCitat = () => (
  <svg
    width="110"
    height="98"
    viewBox="0 0 110 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2664 90.8797C10.9464 88.6397 10.7064 86.3197 10.5464 83.9197C10.3864 81.5197 10.3064 79.7597 10.3064 78.6397C10.3064 67.9197 12.2264 57.7597 16.0664 48.1597C19.9064 38.3997 24.6264 30.1597 30.2264 23.4397L54.4664 28.9597C51.4264 35.8397 48.9464 43.6797 47.0264 52.4797C45.2664 61.1197 44.3864 69.3597 44.3864 77.1997C44.3864 77.5197 44.3864 78.2397 44.3864 79.3597C44.3864 80.3197 44.3864 81.5197 44.3864 82.9597C44.5464 84.2397 44.6264 85.5997 44.6264 87.0397C44.7864 88.4797 44.9464 89.7597 45.1064 90.8797H11.2664ZM62.8664 90.8797C62.5464 88.6397 62.3064 86.3197 62.1464 83.9197C61.9864 81.5197 61.9064 79.7597 61.9064 78.6397C61.9064 67.9197 63.8264 57.7597 67.6664 48.1597C71.5064 38.3997 76.2264 30.1597 81.8264 23.4397L106.066 28.9597C103.026 35.8397 100.546 43.6797 98.6264 52.4797C96.8664 61.1197 95.9864 69.3597 95.9864 77.1997C95.9864 77.5197 95.9864 78.2397 95.9864 79.3597C95.9864 80.3197 95.9864 81.5197 95.9864 82.9597C96.1464 84.2397 96.2264 85.5997 96.2264 87.0397C96.3864 88.4797 96.5464 89.7597 96.7064 90.8797H62.8664Z"
      fill="url(#paint0_linear_2719_839)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2719_839"
        x1="0.706421"
        y1="0.679688"
        x2="66.1171"
        y2="8.57933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00C9BB" />
        <stop offset="1" stopColor="#0098CB" />
      </linearGradient>
    </defs>
  </svg>
);
